import { Chip, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { LowStockItem } from "../types";
import { AnalyticsPanel } from "./AnalyticsVisuals";

const LowStockAnalytics = ({ items, loading }: { items: LowStockItem[]; loading?: boolean }) => {
  const criticalItems = items.filter((item) => item.availableQuantity === 0);
  const lowStockItems = items.filter((item) => item.availableQuantity > 0 && item.availableQuantity <= item.minimumStock);
  return <AnalyticsPanel title="Low Stock Overview" icon={<WarningAmberRoundedIcon color="warning" />}>
    <Stack direction="row" spacing={1} mb={1}>
      <Chip size="small" variant="outlined" color="error" label={`Critical: ${criticalItems.length}`} />
      <Chip size="small" variant="outlined" color="warning" label={`Low stock: ${lowStockItems.length}`} />
    </Stack>
    <TableContainer><Table size="small" aria-label="Low stock spare parts">
      <TableHead><TableRow><TableCell>Part code</TableCell><TableCell>Part name</TableCell><TableCell align="right">Available</TableCell><TableCell align="right">Minimum</TableCell></TableRow></TableHead>
      <TableBody>
        {items.slice(0, 5).map((item) => <TableRow key={item.id} hover>
          <TableCell sx={{ whiteSpace: "nowrap" }}>{item.partCode}</TableCell><TableCell>{item.partName}</TableCell>
          <TableCell align="right"><Chip size="small" color={item.availableQuantity === 0 ? "error" : "warning"} label={item.availableQuantity} /></TableCell><TableCell align="right">{item.minimumStock}</TableCell>
        </TableRow>)}
        {!items.length && <TableRow><TableCell colSpan={4}><Typography variant="body2" color="text.secondary" py={3} textAlign="center">{loading ? "Loading stock levels…" : "No low stock items for this period."}</Typography></TableCell></TableRow>}
      </TableBody>
    </Table></TableContainer>
  </AnalyticsPanel>;
};
export default LowStockAnalytics;
